<template>
	<div class="addressBar">
		<p class="PL fl"><a href="">{{addressBarData.lanmu.Name}}</a></p> 
		<p class="PR fr">当前位置：
			<router-link to="./" >首页 >>&nbsp;</router-link>
			<router-link v-if="addressBarData.PColumn" :href="addressBarData.PColumn.Url" :to="addressBarData.PColumn.Url"  @click.native="OpenLink(item.Url)">{{addressBarData.PColumn.Name}} >>&nbsp;</router-link>
			<router-link :to="addressBarData.lanmu.Url"  :href="addressBarData.lanmu.Url"  @click.native="OpenLink(addressBarData.lanmu.Url)" >{{addressBarData.lanmu.Name}}</router-link>
		</p>
	</div>
</template>

<script>
	export default{
		name:'addressBar',
		props:{
			addressBarData:{
				type: Object,
				  default: () => {
					  return {
						PColumn:{},
						lanmu:{},
						List:[]
					  }
				  }
			},
			moreLink: {
			   type: String,
			   default: ''
			 }
		}
	}
</script>

<style lang="less" scoped="scoped">
	.addressBar{
		height: 30px;
		border-bottom: solid 1px #dadada;
		.PL{
			font-size: 16px;
			font-weight: normal;
			font-stretch: normal;
			line-height: 32px;
			letter-spacing: 1px;
			color: #333333;
		}
		.PR{
			font-size: 16px;
			font-weight: normal;
			font-stretch: normal;
			line-height: 32px;
			letter-spacing: 1px;
			color: #333333;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/addressBar.vue